{
  "help": "도움말",
  "info": "정보"
}
